import React from "react";
import { Card, CardActionArea, CardContent } from "@mui/material";

interface TileCardProps {
  onClick: () => void;
  children: React.ReactNode;
}

const TileCard: React.FC<TileCardProps> = ({ onClick, children }) => (
  <Card
    variant="outlined"
    sx={{
      width: "100%",
      display: "flex",
      minHeight: { xs: 106, lg: 86 },
      borderRadius: "12px",
      border: "1px solid",
      borderColor: "divider",
      backgroundColor: "#f5f5f0",
      transition: "box-shadow 0.2s ease-in-out",
      "&:hover": {
        boxShadow: 2,
      },
    }}
  >
    <CardActionArea onClick={onClick} sx={{ p: 2, flexGrow: 1 }}>
      <CardContent sx={{ p: "0 !important" }}>{children}</CardContent>
    </CardActionArea>
  </Card>
);

export default TileCard;
